module.exports = __webpack_public_path__ + "static/media/piece-demo.68f4ab0d.png";